export default "__VITE_ASSET__IhWm_hN7__"